import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import TableRowColumn from './table-row-column';

import defaultStyles from './table-row.styles';

class TableRow extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
      PropTypes.number,
    ]),
    alignIE: PropTypes.bool,
  };

  render() {
    const { children, style, alignIE } = this.props;

    return (
      <View
        style={[
          defaultStyles.root,
          style,
        ]}
        testID="row"
        alignIE={alignIE}
      >
        {children}
      </View>
    );
  }
}

TableRow.Column = TableRowColumn;

TableRow.defaultProps = {
  alignIE: false,
};

export default TableRow;
